import { useTranslations } from "../../hooks/useTranslations";

interface QuickSearchFormProps {
	query: string;
	searchPageUrl: string;
	onChange: (query: string) => void;
	onFocus: () => void;
}

export default function QuickSearchForm({ query, searchPageUrl, onChange, onFocus }: QuickSearchFormProps) {
	const t = useTranslations();

	return (
		<form action={searchPageUrl} method="get" className="grid w-full grid-cols-1">
			<svg
				className="pointer-events-none absolute top-1/2 left-3 size-5 -translate-y-1/2"
				viewBox="0 0 20 20"
				fill="currentColor"
				aria-hidden="true"
				data-slot="icon"
			>
				<path
					fillRule="evenodd"
					d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z"
					clipRule="evenodd"
				/>
			</svg>
			<input
				type="search"
				name="q"
				value={query}
				className="text-dark-grey border focus:ring-0 focus:outline-none border-light-grey placeholder:text-dark-grey block w-full h-9 rounded-full bg-light-grey py-1.5 pr-3 pl-10 text-sm focus:border-dark-grey"
				placeholder={t.search}
				aria-label={t.search}
				onChange={({ currentTarget }) => {
					onChange(currentTarget.value);
				}}
				onFocus={onFocus}
			/>
		</form>
	);
}
